/**
 * Comparison cluster — batch 3: notarisation vs the two legalisation layers
 * (กรมการกงสุล / สถานทูต). Same content contract as ./index.ts:
 * verdict 50–80 words, >= 6 rows, decisions, myths, >= 6 FAQs, citations.
 * No service fees, no promise that an authority will accept a document.
 */
import type { Comparison } from "./index";

export const COMPARISONS_NOTARY_LEGALISATION: Comparison[] = [
  {
    slug: "notary-vs-consular-legalisation",
    h1: "โนตารีพับลิค กับ การรับรองนิติกรณ์ที่กรมการกงสุล ต่างกันอย่างไร",
    title: "โนตารี vs รับรองนิติกรณ์กรมการกงสุล | เลือกและเรียงลำดับให้ถูก",
    description:
      "โนตารีพับลิคคือทนายผู้ทำคำรับรองลายมือชื่อและเอกสาร ส่วนกรมการกงสุลรับรองนิติกรณ์เอกสารและคำแปล คนละอำนาจ คนละขั้น เทียบครบทั้งลำดับ เอกสารที่ใช้ และสาเหตุถูกตีกลับ",
    cluster: "notary",
    labelA: "โนตารีพับลิค (ทนายผู้ทำคำรับรองลายมือชื่อและเอกสาร)",
    labelB: "การรับรองนิติกรณ์ที่กรมการกงสุล กระทรวงการต่างประเทศ",
    verdict:
      "โนตารีพับลิคในไทยคือทนายความที่ได้รับใบอนุญาตเป็นผู้ทำคำรับรองลายมือชื่อและเอกสารจากสภาทนายความ ใช้รับรองว่าผู้ลงนามมาลงนามต่อหน้า สำเนาตรงกับต้นฉบับ หรือคำสาบานได้กระทำจริง ส่วนกรมการกงสุลรับรองนิติกรณ์ คือรับรองลายมือชื่อและตราประทับของเจ้าหน้าที่ผู้ออกเอกสารหรือผู้รับรองคำแปล สองขั้นนี้แทนกันไม่ได้ และหลายกรณีต้องทำต่อเนื่องกันตามลำดับที่ปลายทางกำหนด",
    rows: [
      {
        dimension: "ผู้มีอำนาจรับรอง",
        a: "ทนายความผู้ทำคำรับรองลายมือชื่อและเอกสาร ที่ขึ้นทะเบียนกับสภาทนายความ",
        b: "เจ้าหน้าที่กองสัญชาติและนิติกรณ์ กรมการกงสุล กระทรวงการต่างประเทศ",
      },
      {
        dimension: "รับรองข้อเท็จจริงใด",
        a: "การแสดงตนและลงนามต่อหน้า ความตรงกันของสำเนากับต้นฉบับ การให้คำสาบานหรือคำแถลง",
        b: "ความถูกต้องของลายมือชื่อและตราประทับของผู้ลงนามในเอกสารราชการหรือผู้รับรองคำแปล",
      },
      {
        dimension: "ประเภทเอกสารที่พบบ่อย",
        a: "เอกสารเอกชน เช่น หนังสือมอบอำนาจ สัญญา แบบฟอร์มธนาคารหรือมหาวิทยาลัยต่างประเทศ สำเนาหนังสือเดินทาง",
        b: "เอกสารราชการไทย เช่น สูติบัตร ทะเบียนสมรส ทะเบียนบ้าน หนังสือรับรองบริษัท และคำแปลของเอกสารเหล่านั้น",
      },
      {
        dimension: "ลำดับขั้นโดยทั่วไป",
        a: "มักเป็นขั้นแรกของเอกสารเอกชนที่ผู้ลงนามเป็นบุคคลหรือกรรมการ",
        b: "ทำหลังจากได้เอกสารราชการต้นทางครบ หรือหลังมีคำแปลที่ผู้แปลรับรองแล้ว",
      },
      {
        dimension: "ต้องแสดงตนหรือไม่",
        a: "ผู้ลงนามต้องมาแสดงตนต่อหน้าผู้รับรองพร้อมเอกสารแสดงตน",
        b: "ผู้ยื่นอาจเป็นผู้แทนที่ได้รับมอบอำนาจ เพราะเป็นการตรวจตัวเอกสารไม่ใช่การลงนามต่อหน้า",
      },
      {
        dimension: "ค่าธรรมเนียม",
        a: "ค่าบริการวิชาชีพตามขอบเขตงานจริง เราแจ้งเป็นใบเสนอราคาเฉพาะเรื่องก่อนเริ่มงาน",
        b: "ค่าธรรมเนียมนิติกรณ์เป็นอัตราของกรมการกงสุล ชำระตามที่หน่วยงานเรียกเก็บในวันยื่น",
      },
      {
        dimension: "ใช้แทนกันได้หรือไม่",
        a: "ใช้แทนนิติกรณ์ไม่ได้ และไม่ทำให้เอกสารใช้ได้กับหน่วยงานราชการต่างประเทศโดยลำพัง",
        b: "ใช้แทนโนตารีไม่ได้ กรมการกงสุลไม่รับรองการลงนามต่อหน้าของเอกชน",
      },
      {
        dimension: "สาเหตุถูกตีกลับที่พบบ่อย",
        a: "ผู้ลงนามไม่มาแสดงตน ถ้อยคำรับรองไม่ตรงกับที่ปลายทางกำหนด หรือเอกสารยังไม่ได้ลงนามให้ครบ",
        b: "ยื่นเฉพาะต้นฉบับแต่ลืมคำแปล คำแปลไม่ครบทุกข้อความรวมตราประทับ หรือชื่อสะกดไม่ตรงหนังสือเดินทาง",
      },
    ],
    decisions: [
      { when: "ปลายทางระบุคำว่า notarised / notarized หรือ before a notary public", pick: "ใช้โนตารีพับลิคก่อน แล้วค่อยดูว่าต้องต่อยอดนิติกรณ์หรือไม่" },
      { when: "ปลายทางเป็นหน่วยงานราชการต่างประเทศ และเอกสารเป็นเอกสารราชการไทย", pick: "ทำคำแปลและรับรองนิติกรณ์ที่กรมการกงสุล ไม่จำเป็นต้องผ่านโนตารี" },
      { when: "เป็นหนังสือมอบอำนาจที่บุคคลลงนามเพื่อใช้กับหน่วยงานราชการต่างประเทศ", pick: "โนตารีก่อน แล้วนำไปรับรองนิติกรณ์ และรับรองที่สถานทูตปลายทางหากกำหนด" },
      { when: "ไม่แน่ใจว่าปลายทางต้องการขั้นใด", pick: "ขอข้อกำหนดเป็นลายลักษณ์อักษรจากผู้รับเอกสารก่อน แล้ววางลำดับให้ครบรอบเดียว" },
    ],
    myths: [
      { myth: "โนตารีพับลิคในไทยเป็นเจ้าหน้าที่รัฐเหมือนต่างประเทศ", truth: "เป็นทนายความที่ได้รับใบอนุญาตจากสภาทนายความให้ทำคำรับรองลายมือชื่อและเอกสาร ไม่ใช่ข้าราชการ" },
      { myth: "ผ่านโนตารีแล้วใช้ได้ทุกประเทศ", truth: "หลายปลายทางยังต้องรับรองนิติกรณ์และ/หรือรับรองที่สถานทูตอีกชั้น ขึ้นกับข้อกำหนดของผู้รับ" },
      { myth: "กรมการกงสุลรับรองว่าเนื้อหาในเอกสารเป็นความจริง", truth: "รับรองลายมือชื่อและตราประทับของผู้ลงนาม ไม่ได้รับรองความถูกต้องของข้อเท็จจริงในเนื้อหา" },
      { myth: "ส่งสำเนาไปรับรองได้เลย", truth: "โดยทั่วไปต้องใช้ต้นฉบับหรือสำเนาที่หน่วยงานผู้ออกรับรอง ไม่ใช่สำเนาถ่ายเอง" },
    ],
    faqs: [
      {
        question: "โนตารีพับลิคกับรับรองนิติกรณ์ ต้องทำทั้งสองอย่างไหม",
        answer:
          "ขึ้นกับประเภทเอกสารและข้อกำหนดของผู้รับปลายทาง เอกสารเอกชนที่บุคคลลงนามและจะนำไปใช้กับหน่วยงานราชการต่างประเทศ มักต้องผ่านโนตารีก่อนแล้วรับรองนิติกรณ์ต่อ ส่วนเอกสารราชการไทยพร้อมคำแปลมักเข้าขั้นนิติกรณ์ได้โดยไม่ต้องผ่านโนตารี แนวปฏิบัติที่ปลอดภัยคือขอข้อกำหนดเป็นลายลักษณ์อักษรจากผู้รับก่อนวางลำดับ",
      },
      {
        question: "ทนายโนตารีในไทยตรวจสอบได้อย่างไร",
        answer:
          "ตรวจได้จากทะเบียนของสภาทนายความ ผู้ทำคำรับรองลายมือชื่อและเอกสารต้องมีใบอนุญาตทนายความและได้รับหนังสือรับรองการขึ้นทะเบียนเป็นผู้ทำคำรับรอง ควรขอดูเลขที่ใบอนุญาตและชื่อผู้รับรองก่อนลงนาม เพราะปลายทางบางแห่งตรวจย้อนกลับ",
      },
      {
        question: "ใช้เวลาแต่ละขั้นเท่าใด",
        answer:
          "ขั้นโนตารีมักดำเนินการได้ภายในวันเดียวหากผู้ลงนามมาแสดงตนพร้อมเอกสารครบ ขั้นนิติกรณ์ที่กรมการกงสุลขึ้นกับช่องทางและปริมาณคำขอในวันนั้น จึงควรสอบถามกำหนดจากหน่วยงานในวันยื่นและเผื่อเวลาสำหรับขั้นสถานทูตต่อไป",
      },
      {
        question: "คำแปลต้องทำก่อนหรือหลังโนตารี",
        answer:
          "ตามหลักควรให้เอกสารมีลายมือชื่อและตราประทับครบก่อน จึงแปลทั้งฉบับรวมข้อความบนตราประทับและคำรับรอง เพราะถ้าแปลก่อนแล้วมีการรับรองเพิ่มภายหลัง คำแปลจะไม่ครบและมักถูกให้แก้ไข",
      },
      {
        question: "มอบอำนาจให้คนอื่นไปยื่นนิติกรณ์แทนได้ไหม",
        answer:
          "โดยทั่วไปทำได้ เพราะเป็นการตรวจตัวเอกสาร แต่ควรจัดทำหนังสือมอบอำนาจให้ครอบคลุมทุกขั้นที่ผู้แทนต้องทำ รวมการรับเอกสารคืนและการแก้ไขเอกสารตามที่เจ้าหน้าที่แจ้ง ส่วนขั้นโนตารีผู้ลงนามต้องมาด้วยตนเอง",
      },
      {
        question: "เอกสารที่รับรองแล้วมีอายุการใช้งานเท่าใด",
        answer:
          "ตัวคำรับรองไม่ได้กำหนดวันหมดอายุในตัวเอง แต่ผู้รับปลายทางมักกำหนดว่าต้องออกไม่เกินระยะเวลาหนึ่งก่อนวันยื่น เช่น 3 หรือ 6 เดือน จึงควรวางลำดับให้ใกล้กับกำหนดยื่นจริง",
      },
      {
        question: "อยู่ต่างประเทศจะดำเนินการอย่างไร",
        answer:
          "ทำได้สองแนวทางคือให้ผู้แทนในไทยดำเนินการตามหนังสือมอบอำนาจที่รับรองถูกต้อง หรือดำเนินการที่สถานเอกอัครราชทูต/สถานกงสุลไทยในประเทศที่พำนักตามเงื่อนไขของแต่ละแห่ง ควรตรวจเงื่อนไขก่อนจัดทำหนังสือมอบอำนาจเพื่อให้ถ้อยคำครอบคลุม",
      },
    ],
    citations: [
      { label: "กรมการกงสุล กระทรวงการต่างประเทศ — งานนิติกรณ์", href: "https://consular.mfa.go.th" },
      { label: "สภาทนายความในพระบรมราชูปถัมภ์", href: "https://www.lawyerscouncil.or.th" },
    ],
    related: [
      { label: "บริการโนตารีพับลิค", to: "/notary" },
      { label: "Apostille และนิติกรณ์", to: "/apostille" },
      { label: "แปลและรับรองคำแปล", to: "/translation" },
    ],
  },
  {
    slug: "notary-vs-embassy-certification",
    h1: "โนตารีพับลิค กับ การรับรองที่สถานทูต ต่างกันอย่างไร ต้องทำขั้นไหนก่อน",
    title: "โนตารี vs รับรองที่สถานทูต | ลำดับขั้นที่ปลายทางยอมรับ",
    description:
      "โนตารีรับรองลายมือชื่อและเอกสารของเอกชน ส่วนสถานทูตรับรองเพื่อให้เอกสารใช้ได้ในประเทศของตน เทียบอำนาจ ลำดับขั้น เอกสาร และจุดที่ทำให้ต้องเริ่มใหม่ทั้งชุด",
    cluster: "notary",
    labelA: "โนตารีพับลิค (ขั้นรับรองในประเทศไทย)",
    labelB: "การรับรองที่สถานทูตหรือสถานกงสุลของประเทศปลายทาง",
    verdict:
      "โนตารีพับลิครับรองว่าผู้ลงนามมาลงนามต่อหน้า หรือสำเนาตรงกับต้นฉบับ เป็นขั้นในประเทศไทย ส่วนการรับรองที่สถานทูตคือขั้นสุดท้ายที่ประเทศปลายทางยืนยันว่ายอมรับลายมือชื่อและตราประทับที่ปรากฏบนเอกสาร โดยทั่วไปต้องเรียงจากต้นทางไปปลายทาง คือโนตารีหรือหน่วยงานผู้ออกเอกสาร แล้วรับรองนิติกรณ์ที่กรมการกงสุล แล้วจึงยื่นสถานทูต สลับลำดับมักถูกปฏิเสธและต้องทำใหม่ทั้งชุด",
    rows: [
      {
        dimension: "ผู้รับรอง",
        a: "ทนายความผู้ทำคำรับรองลายมือชื่อและเอกสาร ตามทะเบียนของสภาทนายความ",
        b: "เจ้าหน้าที่สถานเอกอัครราชทูตหรือสถานกงสุลของประเทศที่จะนำเอกสารไปใช้",
      },
      { dimension: "รับรองเพื่ออะไร", a: "ยืนยันการลงนามต่อหน้า สำเนาถูกต้อง หรือคำสาบาน", b: "ยืนยันว่าประเทศปลายทางยอมรับลายมือชื่อและตราประทับที่ปรากฏก่อนหน้า" },
      { dimension: "ตำแหน่งในลำดับขั้น", a: "ขั้นต้น สำหรับเอกสารเอกชน", b: "ขั้นสุดท้ายก่อนนำไปยื่นต่อหน่วยงานในประเทศนั้น" },
      { dimension: "เงื่อนไขก่อนยื่น", a: "ผู้ลงนามแสดงตนพร้อมเอกสารแสดงตนและเอกสารที่จะลงนาม", b: "ต้องผ่านการรับรองนิติกรณ์ของกรมการกงสุลมาก่อน ตามที่แต่ละสถานทูตกำหนด" },
      { dimension: "ภาษาคำแปล", a: "รับรองบนเอกสารตามภาษาที่จัดทำ ไม่ใช่การรับรองคุณภาพคำแปล", b: "หลายแห่งกำหนดภาษาคำแปลและผู้แปลที่ยอมรับ ควรตรวจก่อนจ้างแปล" },
      { dimension: "ค่าธรรมเนียม", a: "ค่าบริการวิชาชีพตามขอบเขตงาน แจ้งเป็นใบเสนอราคาเฉพาะเรื่อง", b: "ค่าธรรมเนียมตามอัตราที่สถานทูตแต่ละแห่งประกาศ ชำระตามช่องทางที่กำหนด" },
      { dimension: "ประเทศภาคีอนุสัญญากรุงเฮก", a: "ไม่เกี่ยวโดยตรง ยังใช้เป็นขั้นต้นได้เหมือนเดิม", b: "หากปลายทางรับ Apostille อาจไม่ต้องผ่านสถานทูต ควรตรวจสถานะภาคีและแนวปฏิบัติล่าสุด" },
      { dimension: "สาเหตุที่ต้องเริ่มใหม่ทั้งชุด", a: "ถ้อยคำรับรองไม่ตรงแบบที่ปลายทางกำหนด", b: "ข้ามขั้นนิติกรณ์ คำแปลไม่ครบ หรือเอกสารออกเกินระยะเวลาที่ปลายทางยอมรับ" },
    ],
    decisions: [
      { when: "ปลายทางเป็นประเทศภาคีอนุสัญญากรุงเฮกและรับ Apostille", pick: "วางลำดับเป็นโนตารี (ถ้าจำเป็น) แล้วขอ Apostille โดยไม่ต้องผ่านสถานทูต" },
      { when: "ปลายทางไม่ใช่ภาคี หรือกำหนดให้มีตราสถานทูต", pick: "โนตารีหรือหน่วยงานผู้ออก แล้วนิติกรณ์กรมการกงสุล แล้วจึงยื่นสถานทูต" },
      { when: "เป็นเอกสารราชการไทยพร้อมคำแปล", pick: "ไม่ต้องผ่านโนตารี ให้เข้าขั้นรับรองคำแปลและนิติกรณ์ตามลำดับ" },
      { when: "มีกำหนดยื่นที่ปลายทางกระชั้น", pick: "ตรวจข้อกำหนดและคิวของแต่ละขั้นก่อน แล้วจัดลำดับให้เอกสารไม่หมดอายุระหว่างรอ" },
    ],
    myths: [
      { myth: "รับรองที่สถานทูตแล้วไม่ต้องทำนิติกรณ์", truth: "สถานทูตส่วนใหญ่รับเฉพาะเอกสารที่ผ่านนิติกรณ์ของกรมการกงสุลมาแล้ว" },
      { myth: "สถานทูตรับรองว่าเนื้อหาเอกสารเป็นความจริง", truth: "รับรองลายมือชื่อและตราประทับตามลำดับที่ปรากฏ ไม่ได้วินิจฉัยข้อเท็จจริงในเนื้อหา" },
      { myth: "ทุกประเทศใช้ลำดับขั้นเดียวกัน", truth: "แต่ละสถานทูตกำหนดเอกสาร ภาษา และช่องทางนัดต่างกัน ควรตรวจประกาศของสถานทูตนั้นก่อน" },
      { myth: "ทนายรับประกันได้ว่าปลายทางจะรับเอกสาร", truth: "การยอมรับเป็นดุลพินิจของหน่วยงานผู้รับ ทนายทำได้คือวางลำดับให้ครบตามข้อกำหนดที่ปรากฏ" },
    ],
    faqs: [
      {
        question: "ต้องทำโนตารีก่อนไปสถานทูตทุกครั้งไหม",
        answer:
          "ไม่ทุกครั้ง ขั้นโนตารีใช้กับเอกสารเอกชนที่ต้องยืนยันการลงนามหรือความถูกต้องของสำเนา ส่วนเอกสารราชการไทยเข้าสู่ขั้นรับรองคำแปลและนิติกรณ์ได้โดยตรง แนวปฏิบัติที่ปลอดภัยคือดูประกาศของสถานทูตปลายทางว่ากำหนดชุดเอกสารแบบใด",
      },
      {
        question: "สลับลำดับขั้นจะเกิดอะไรขึ้น",
        answer:
          "มักถูกปฏิเสธและต้องเริ่มใหม่ เพราะแต่ละขั้นรับรองลายมือชื่อของขั้นก่อนหน้า หากนำเอกสารที่ยังไม่ผ่านนิติกรณ์ไปยื่นสถานทูต เจ้าหน้าที่จะไม่มีตราประทับที่ตนยอมรับไว้ให้ตรวจ",
      },
      {
        question: "เอกสารที่ทำ Apostille แล้วต้องไปสถานทูตอีกไหม",
        answer:
          "หากประเทศปลายทางเป็นภาคีอนุสัญญากรุงเฮกและยอมรับ Apostille ตามแนวปฏิบัติปัจจุบัน โดยหลักไม่ต้องผ่านสถานทูตอีกชั้น แต่หน่วยงานผู้รับบางแห่งยังขอคำแปลหรือเอกสารประกอบเพิ่ม ควรยืนยันกับผู้รับก่อนยื่น",
      },
      {
        question: "คำแปลต้องแปลโดยใคร",
        answer:
          "ขึ้นกับข้อกำหนดของปลายทาง บางแห่งกำหนดผู้แปลที่ขึ้นทะเบียนหรือรับรองโดยหน่วยงานที่กำหนด บางแห่งรับคำแปลที่ผ่านการรับรองคำแปลตามขั้นของกรมการกงสุล ควรตรวจก่อนจ้างแปลเพื่อไม่ต้องแปลซ้ำ",
      },
      {
        question: "ต้องนัดคิวสถานทูตล่วงหน้าไหม",
        answer:
          "หลายแห่งกำหนดให้นัดล่วงหน้าผ่านระบบออนไลน์และจำกัดจำนวนคำขอต่อวัน จึงควรตรวจช่องทางนัดและวันหยุดของสถานทูตนั้นตั้งแต่ต้น เพราะรอบคิวมีผลต่อกำหนดยื่นที่ปลายทาง",
      },
      {
        question: "เอกสารเก่าเกินไปใช้ไม่ได้จริงหรือ",
        answer:
          "ผู้รับปลายทางหลายแห่งกำหนดว่าเอกสารต้องออกไม่เกินระยะเวลาหนึ่งก่อนวันยื่น จึงควรวางลำดับให้ขอเอกสารใกล้กำหนดยื่นจริง และไม่เริ่มขั้นรับรองไว้ล่วงหน้านานเกินไป",
      },
      {
        question: "ให้สำนักงานดำเนินการแทนได้ทุกขั้นไหม",
        answer:
          "ขั้นนิติกรณ์และขั้นสถานทูตโดยทั่วไปมอบอำนาจให้ผู้แทนดำเนินการได้ตามเงื่อนไขของแต่ละแห่ง แต่ขั้นโนตารีผู้ลงนามต้องแสดงตนด้วยตนเอง เราจะแจ้งชัดว่าขั้นใดต้องมาเอง และขั้นใดมอบอำนาจได้ พร้อมขอบเขตงานและค่าบริการเป็นลายลักษณ์อักษรก่อนเริ่มงาน",
      },
    ],
    citations: [
      { label: "กรมการกงสุล กระทรวงการต่างประเทศ — งานนิติกรณ์", href: "https://consular.mfa.go.th" },
      { label: "HCCH — สถานะภาคีอนุสัญญา Apostille", href: "https://www.hcch.net" },
      { label: "สภาทนายความในพระบรมราชูปถัมภ์", href: "https://www.lawyerscouncil.or.th" },
    ],
    related: [
      { label: "บริการโนตารีพับลิค", to: "/notary" },
      { label: "Apostille และนิติกรณ์", to: "/apostille" },
      { label: "รับรองเอกสารที่สถานทูต", to: "/embassy" },
    ],
  },
];
